import { BaseResource } from "./BaseResource";
import { apiResourceUrl } from "@ploy-lib/core";
export class VendorProductGroupResource extends BaseResource {
    pk() {
        return this.vendorProductGroupId.toString();
    }
}
VendorProductGroupResource.urlRoot = apiResourceUrl("vendorProductGroups");
//# sourceMappingURL=VendorProductGroupResource.js.map